// @flow
import * as ActionTypes from 'constants/ActionTypes';

const initialState = {
  serviceError: "",
  serviceCode: 200,
  reqStatus: "",
  isLoading: false,
  packages: [],
  featuredPackages: [],
  checkoutVerification: null,
  createdOrder: null,
  orders: [],
  orderDetail: null,
  ordersCount: 0,
  paymentOrder: null,
  paymentVerification: null,
};

export default function(state: Object = initialState, action: Object) {
  switch (action.type) {
    /* Common Triggers */
    case ActionTypes.GET_TRYON_PACKAGES_START:
    case ActionTypes.GET_TRYON_FEATURED_PACKAGES_START:
    case ActionTypes.VERIFY_TRYON_CHECKOUT_START:
    case ActionTypes.CREATE_TRYON_ORDER_START:
    case ActionTypes.COMPLETE_TRYON_ORDER_START:
    case ActionTypes.GET_TRYON_ORDERS_START:
    case ActionTypes.GET_TRYON_ORDER_DETAIL_START:
    case ActionTypes.CREATE_TRYON_PAYMENT_ORDER_START:
    case ActionTypes.VERIFY_TRYON_PAYMENT_START:
      return {
        ...state,
        isLoading: true,
        serviceError: "",
        reqStatus: "",
      };

    /* Get Packages */
    case ActionTypes.GET_TRYON_PACKAGES_SUCCESS:
      return {
        ...state,
        isLoading: false,
        packages: action.payload.response.packages || [],
        reqStatus: action.type,
      };

    case ActionTypes.GET_TRYON_PACKAGES_FAILURE:
      return {
        ...state,
        isLoading: false,
        serviceError: action.payload,
        reqStatus: action.type,
      };

    /* Get Featured Packages */
    case ActionTypes.GET_TRYON_FEATURED_PACKAGES_SUCCESS:
      return {
        ...state,
        isLoading: false,
        featuredPackages: action.payload.response.packages || [],
        reqStatus: action.type,
      };

    case ActionTypes.GET_TRYON_FEATURED_PACKAGES_FAILURE:
      return {
        ...state,
        isLoading: false,
        serviceError: action.payload,
        reqStatus: action.type,
      };

    /* Verify Checkout */
    case ActionTypes.VERIFY_TRYON_CHECKOUT_SUCCESS:
      return {
        ...state,
        isLoading: false,
        checkoutVerification: action.payload.response,
        reqStatus: action.type,
      };

    case ActionTypes.VERIFY_TRYON_CHECKOUT_FAILURE:
      return {
        ...state,
        isLoading: false,
        serviceError: action.payload,
        reqStatus: action.type,
      };

    /* Create Order */
    case ActionTypes.CREATE_TRYON_ORDER_SUCCESS:
      return {
        ...state,
        isLoading: false,
        createdOrder: action.payload.response,
        reqStatus: action.type,
      };

    case ActionTypes.CREATE_TRYON_ORDER_FAILURE:
      return {
        ...state,
        isLoading: false,
        serviceError: action.payload,
        reqStatus: action.type,
      };

    /* Complete Order */
    case ActionTypes.COMPLETE_TRYON_ORDER_SUCCESS:
      return {
        ...state,
        isLoading: false,
        reqStatus: action.type,
      };

    case ActionTypes.COMPLETE_TRYON_ORDER_FAILURE:
      return {
        ...state,
        isLoading: false,
        serviceError: action.payload,
        reqStatus: action.type,
      };

    /* Get Orders */
    case ActionTypes.GET_TRYON_ORDERS_SUCCESS:
      return {
        ...state,
        isLoading: false,
        orders: action.payload.response.orders || [],
        ordersCount: action.payload.response.count || 0,
        reqStatus: action.type,
      };

    case ActionTypes.GET_TRYON_ORDERS_FAILURE:
      return {
        ...state,
        isLoading: false,
        serviceError: action.payload,
        reqStatus: action.type,
      };

    /* Get Order Detail */
    case ActionTypes.GET_TRYON_ORDER_DETAIL_SUCCESS:
      return {
        ...state,
        isLoading: false,
        orderDetail: action.payload.response.order || null,
        reqStatus: action.type,
      };

    case ActionTypes.GET_TRYON_ORDER_DETAIL_FAILURE:
      return {
        ...state,
        isLoading: false,
        serviceError: action.payload,
        reqStatus: action.type,
      };

    /* Create Payment Order */
    case ActionTypes.CREATE_TRYON_PAYMENT_ORDER_SUCCESS:
      return {
        ...state,
        isLoading: false,
        paymentOrder: action.payload.response,
        reqStatus: action.type,
      };

    case ActionTypes.CREATE_TRYON_PAYMENT_ORDER_FAILURE:
      return {
        ...state,
        isLoading: false,
        serviceError: action.payload,
        reqStatus: action.type,
      };

    /* Verify Payment */
    case ActionTypes.VERIFY_TRYON_PAYMENT_SUCCESS:
      return {
        ...state,
        isLoading: false,
        paymentVerification: action.payload.response,
        reqStatus: action.type,
      };

    case ActionTypes.VERIFY_TRYON_PAYMENT_FAILURE:
      return {
        ...state,
        isLoading: false,
        serviceError: action.payload,
        reqStatus: action.type,
      };

    default:
      return state;
  }
}
